import React, {FC, useLayoutEffect, useRef} from 'react'
import styled from 'styled-components'
import {Box} from '@miro-site/core'
import type {BoxProps} from '@miro-site/core'

export interface ContentProps extends BoxProps {
  children: React.ReactNode
  isExpanded: boolean
}

const StyledContent = styled(Box)`
  overflow: hidden;
  transition: height 0.2s ease-in-out, padding 0.2s ease-in-out;
  border-bottom: 1px solid ${({theme}) => theme.templates.colors.secondary8};
`

const Content: FC<ContentProps> = ({children, isExpanded, ...props}) => {
  const contentEl = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const {current} = contentEl

    if (current) {
      const contentHeight = `${current.scrollHeight}px`

      if (isExpanded) {
        requestAnimationFrame(function () {
          current.style.height = '0'

          requestAnimationFrame(function () {
            current.style.height = contentHeight
          })
        })
      } else {
        requestAnimationFrame(function () {
          current.style.height = '0'
        })
      }
    }
  }, [isExpanded])

  return (
    <StyledContent ref={contentEl} {...props}>
      {children}
    </StyledContent>
  )
}

export default Content
